import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { AuthService } from "./auth.service";

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authStore = inject(AuthService);
  if (req.url.includes(environment.backendBaseUrl)) {
    const { token_type, access_token, subscription } = authStore.token;
    req = req.clone({
      setHeaders: {
        "Authorization": token_type + " " + access_token,
        "Ocp-Apim-Subscription-Key": subscription,
      },
    });
    return next(req).pipe(catchError(e => {
      authStore.login();
      throw e;
    }));
  }
  return next(req);
};
